import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <FeaturesSection />
        <AboutSection />
        <ContactSection />
        <FaqSection />
        <AppSection />
        <RankingSection />
        <TopicsSection />
        <CardsSection />
        <CommentsSection />
        <UpdatesSection />
        <CarouselSection />
        <IndexSection />
      </main>
      <Footer />
    </div>
  );
}